<template>
  <div class="fill-height">
    <line-chart
      v-if="viewMode === 'chart'"
      class="fill-height"
      :raw-data="players"
      :chart-value-keys="chartValueKeys"
      x-value="last_name"
      :y-value-prefix="aggregation && !removable ? 'latest_stats.' : 'player_stats.'"
      :yaxis="[ { title: { text: $t('hr_variables.trimp') }}, { title: { text: $t('hr_variables.trimp_min') }, opposite: true} ]"
      :xaxis="{
        labels: {
          rotate: -45
        },
        categories: players.map(p => p.first_name[0] + '. ' + p.last_name ),
        tickPlacement: 'between'
      }"
      :colors="[ '#f65de2', '#775DD0' ]"
      :fill="{ opacity: [1, 1]}"
    >
      <template v-slot:header>
        <v-card-title class="pa-4">
          <v-row
            no-gutters
            align="center"
          >
            <v-col>
              <div
                class="subtitle-2 grey--text text--grey-100"
                style="word-break: normal"
              >
                {{ aggregation ? $t(`variables.${aggregation}.long`) + ":" : '' }} {{ $t('table_headers.trimp_training_impulse') }}
              </div>
            </v-col>
            <v-col
              cols="auto"
              class="ml-3 "
            >
              <v-btn
                v-if="removable"
                icon
                style="pointer-events: auto"
                @click="$emit('remove')"
              >
                <v-icon small>
                  fal fa-times
                </v-icon>
              </v-btn>
              <visual-list-toggle
                v-else
                :value.sync="viewMode"
              />
            </v-col>
          </v-row>
        </v-card-title>
      </template>
    </line-chart>

    <v-card
      v-else-if="viewMode === 'table'"
      class="fill-height rounded-lg"
    >
      <v-card-title class="pa-4">
        <v-row
          no-gutters
          align="center"
        >
          <v-col>
            <div
              class="subtitle-2 grey--text text--grey-100"
              style="word-break: normal"
            >
              {{ aggregation ? $t(`variables.${aggregation}.long`) + ":" : '' }} {{ $t('table_headers.trimp_training_impulse') }}
            </div>
          </v-col>
          <v-col
            cols="auto"
            class="ml-3 "
          >
            <visual-list-toggle
              v-if="!removable"
              :value.sync="viewMode"
            />
          </v-col>
        </v-row>
      </v-card-title>

      <chart-list-view-table
        :headers="tableHeaders"
        :items="players"
      >
        <template v-slot:item.last_name="{ item }">
          {{ item.last_name }}, {{ item.first_name }}
        </template>
      </chart-list-view-table>
    </v-card>
  </div>
</template>

<script>
import LineChart from '@/components/charts/LineChart.vue'
import VisualListToggle from '@/components/buttons/VisualListToggle.vue'
import ChartListViewTable from '@/components/charts/implementation/ChartListViewTable.vue'

export default {
  name: 'TrimpMinChart',
  components: { ChartListViewTable, LineChart, VisualListToggle },
  props: {
    players: {
      type: Array,
      required: true
    },
    removable: {
      type: Boolean,
      default: false
    },
    aggregation: {
      type: String,
      default: null
    }
  },
  data: () => ({
    viewMode: 'chart'
  }),
  computed: {
    chartValueKeys() {
      const addAggregation = (key) => this.aggregation && !this.removable ? `${key}_${this.aggregation}` : key
      return [
        { key: addAggregation('TRIMPMIN'), type: 'line', label: 'TRIMP/min' },
        { key: addAggregation('TRIMP'), type: 'bar', label: 'TRIMP' }
      ]
    },
    tableHeaders() {
      const addAggregation = (key) => this.aggregation && !this.removable ? `${key}_${this.aggregation}` : key
      const valuePrefix = this.aggregation && !this.removable ? 'latest_stats.' : 'player_stats.'

      return [
        {
          text: this.$t('table_headers.name'),
          value: 'last_name',
          sortable: true,
          width: '40%'
        },
        {
          text: this.$t('hr_variables.trimp'),
          value: valuePrefix + addAggregation('TRIMP'),
          sortable: true,
          align: 'center'
        },
        {
          text: this.$t('hr_variables.trimp_min'),
          value: valuePrefix + addAggregation('TRIMPMIN'),
          sortable: true,
          align: 'center'
        }
      ]
    }
  }
}
</script>
